"use client";
import { Size } from "@/api/AppApi/common-interfaces/api-enums";
import { IProduct } from "@/api/AppApi/services/home/interfaces/IProduct";
import ProductImg from "./ProductImg";
import { ITheme } from "@/api/AppApi/services/company/interfaces/ICompany";
import { useProductBox } from "../../context/ProductBoxContext";

interface Props {
  scrollableTabs: boolean;
  size: Size;
  priority: boolean;
  theme: ITheme | undefined;
}

const ProductBoxImage: React.FC<Props> = ({
  size,
  priority,
  scrollableTabs,
  theme,
}) => {
  const { selectedChild, outOfStock } = useProductBox();
  return (
    <ProductImg
      discount={selectedChild.discount}
      className={`${
        scrollableTabs
          ? "product-box-image-scrollable-tabs"
          : "product-image-container"
      } `}
      src={selectedChild?.thumbnail_url ?? selectedChild.image_url}
      size={size}
      is_new={selectedChild.is_new}
      has_discount={
        selectedChild.has_discount || selectedChild.discount_amount > 0
      }
      discount_type={selectedChild.discount_type}
      discount_amount={selectedChild.discount_amount}
      priority={priority}
      theme={theme}
      images={(selectedChild?.images ?? []) as IProduct["images"]}
      outOfStock={outOfStock}
    />
  );
};

export default ProductBoxImage;
